import EmailStatus from "@mapmycustomers/shared/enum/EmailStatus";
import Email from "@mapmycustomers/shared/types/email/Email";

type SentEmail = Pick<Email, "hasBounced" | "status">;

// Whether the send to this recipient failed outright, by the same rule the processor uses to
// keep a recipient out of the activity's contacts. Both halves count: a bounce is recorded
// after the send succeeded, so a bounced row still reads SENT, and ERRORED is not
// bounce-specific.
const isEmailDeliveryFailed = (email: SentEmail): boolean =>
  !!email.hasBounced ||
  email.status === EmailStatus.CANCELLED ||
  email.status === EmailStatus.ERRORED;

export default isEmailDeliveryFailed;
